import React from 'react';
export function StatsBar() {
  return <div className="bg-brand-ink border-y border-brand-border py-6 px-6" data-id="element-270">
      <div className="max-w-[1060px] mx-auto flex flex-wrap justify-center gap-9" data-id="element-271">
        <div className="text-center" data-id="element-272">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-273">
            +2.500
          </span>
          <span className="text-xs text-brand-muted" data-id="element-274">Mujeres satisfechas</span>
        </div>
        <div className="text-center" data-id="element-275">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-276">
            6
          </span>
          <span className="text-xs text-brand-muted" data-id="element-277">Tomos completos</span>
        </div>
        <div className="text-center" data-id="element-278">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-279">
            6
          </span>
          <span className="text-xs text-brand-muted" data-id="element-280">Bonos incluidos</span>
        </div>
        <div className="text-center" data-id="element-281">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-282">
            4.9 ⭐
          </span>
          <span className="text-xs text-brand-muted" data-id="element-283">
            Calificación promedio
          </span>
        </div>
      </div>
    </div>;
}